/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Button, ButtonProps } from "@nordcloud/gnui";

export function EditButton({ onClick }: ButtonProps) {
  return (
    <Button
      severity="low"
      size="sm"
      icon="edit"
      aria-pressed="false"
      css={{ margin: 0, borderRadius: "22px", padding: "0.3rem" }}
      data-testid="btn-edit"
      onClick={onClick}
    />
  );
}
